import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/produto/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group relative flex flex-col border border-[#27272A] bg-[#151618] transition-colors duration-200 hover:border-[#FF5500]"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-black">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3">
          <StatusBadge status={product.status} />
        </div>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-heading text-lg font-bold text-white">{product.name}</h3>
        <p className="mt-2 flex-1 text-sm text-[#A1A1AA]">{product.short_description}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF5500]">
          Ver detalhes <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
